import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  debug: true,
  state: {
      responseError: null,
      panelComponent: 'LocationForm',
      locationOptions: [
          { value: null, text: "Peraustraße 32/7" }
      ],
      locationSafe: {
          zip: null,
          city: null,
          street: null,
          streetNo: null,
          door: null,
          stair: null,
          floor: null,
          block: null
      },
      visible: false,
      loading: false,
  },
  mutations: {
    setLocations(state, locations){
        var generatedLocations = []
        for(var i in locations){
            var translatedData = {
                street: locations[i].strasse,
                streetNo: locations[i].hausnummer,
                zip: locations[i].postleitzahl,
                city: locations[i].ort,
                door: locations[i].tuer,
                floor: locations[i].stockwerk,
                stair: locations[i].stiege,
                block: locations[i].block
            };
            generatedLocations.push({
                text: translatedData.street + ' ' + [translatedData.streetNo, translatedData.door, translatedData.stair, translatedData.floor,translatedData.block].filter(el => el != '').join('/'),
                value: translatedData
            });
        }
       state.locationOptions = generatedLocations;
    },
    setResponseError(state, message){
       state.responseError = message;
    },
    setPanelComponent(state, component){
        state.panelComponent = component;
    },
      saveLocation(state, location){
          state.locationSafe = location;
      },
      hidePanel(state, event = null){
        if(event){
            event.preventDefault();
        }
        state.visible = false;
      },
      showPanel(state, event = null){
          if(event){
              event.preventDefault();
          }
        state.visible = true;
      },
      hideLoading(state, event = null){
        if(event){
            event.preventDefault();
        }
        state.loading = false;
      },
      showLoading(state, event = null){
          if(event){
              event.preventDefault();
          }
        state.loading = true;
      }

  },
  actions: {

  }
})
